var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "membership-success clearfix" }, [
    _c("canvas", {
      staticClass: "animated fadeIn",
      attrs: { id: "confetti-canvas" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "complete-header animated fadeInUp" }, [
        _c("h1", { staticClass: "center" }, [
          _c("img", {
            staticClass: "diamond animated fadeInUp",
            attrs: {
              src: "https://assets.tablelist.com/www-2/tablelist/tl-membership-diamond@3x.png",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "animated fadeInUp delay-three" }, [
            _vm._v("\n          Welcome to\n        "),
          ]),
          _vm._v(" "),
          _vm.affiliate.membershipName
            ? _c("span", { staticClass: "animated fadeInUp delay-three" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.affiliate.membershipName) +
                    " Membership!\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.affiliate.membershipName
            ? _c("span", { staticClass: "animated fadeInUp delay-three" }, [
                _vm._v("\n          Diamond Membership!\n        "),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "perks-cta center animated fadeInUp delay-three" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-primary",
              attrs: { to: { name: "MembershipPerks" } },
            },
            [_vm._v("\n        See Perks\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "referral animated fadeInUp delay-one" }, [
        _c("h2", { staticClass: "center" }, [_vm._v("Sharing is caring 🧑🏼‍🤝‍🧑🏻")]),
        _vm._v(" "),
        _c("h3", { staticClass: "center" }, [
          _vm._v("Refer your friends to give them their first month free!"),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.user.referralCode,
              expression: "user.referralCode",
            },
            {
              name: "clipboard",
              rawName: "v-clipboard",
              value: _vm.user.referralCode,
              expression: "user.referralCode",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text", readonly: "readonly" },
          domProps: { value: _vm.user.referralCode },
          on: {
            success: _vm.onReferralCodeCopied,
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.user, "referralCode", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "disclaimer" }, [
          _vm._v(
            "\n        *Have your friends enter the code above at checkout.\n      "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/MembershipSuccess/template.html?vue&type=template&id=b8b0e4e0&
// module id = 1068
// module chunks = 0